import { createSlice } from "@reduxjs/toolkit";
import { SequenceResponseDto } from "../../shared/dtos/sequence/SequenceResponseDto";
import {
  getInitialListState,
  generateListReducers,
} from "../utils/listFactory";

export const sequenceSlice = createSlice({
  name: "sequence",
  initialState: getInitialListState<SequenceResponseDto>(),
  reducers: {
    ...generateListReducers<SequenceResponseDto>(),
  },
});

export const sequenceActions = sequenceSlice.actions;
export default sequenceSlice.reducer;
